<!--  -->
<template>
  <div class="manzu">
    <div class="manzu-main">
      <div class="manzu-copd">
        <div class="copd-img">
          <img src="../../assets/manzu1.png" />
        </div>
        <div class="copd-msg">
          <h1>COPD：高居全球前三的致死疾病</h1>
          <div v-html="copdMsg"></div>
        </div>
      </div>
      <div class="copdNumb">
        <img src="../../assets/copd.png" />
      </div>

      <div class="steam">
        <div class="steam-text">
          <h1>热蒸汽消融术——世界公认，常规治疗手段之一</h1>
          <div class="steam-msg" v-html="steamMsg"></div>
        </div>
        <div class="steam-img">
          <img src="../../assets/steam1.png" />
          <img src="../../assets/steam2.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      copdMsg: `• 目前，全世界约有3.28亿人患有慢性阻塞性肺病，其中1.68亿男性和1.6亿女性。
•  2016年，全世界有300万人死于慢性阻塞性肺病, 为第三大致死疾病。
• 大部分重度慢阻肺患者生活质量非常低且无有效治疗手段，5年生存率不到20%。
• 中国慢肺阻（COPD）患病人数约1亿人，死亡人数居全球首位，年死亡近100万人。 `,
      steamMsg: `•   STEP-UP临床试验的结果在世界权威医学杂志《柳叶刀》上发表。
• InterVapor®于2017年3月获得治疗上肺叶为主的非均质性肺气肿的CE认证。
• InterVapor®治疗被纳入2019和2020慢性阻塞性肺疾病全球倡议（Gold指南）。
• InterVapor®在欧洲主流国家（英国、德国、瑞士、意大利等）和亚太的17个国家和地区进入临床应用。`,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../scss/public.scss";
.manzu {
  width: 100%;
  .manzu-main {
    width: $main-width;
    margin: 0 auto;
    .manzu-copd {
      display: flex;
      justify-content: space-between;
      .copd-img {
        width: 50%;
        padding: 40px 0;
      }
      .copd-msg {
        width: 45%;
        h1 {
          color: #8553a2;
          font-size: 1.4rem;
          font-weight: bold;
        }
      }
    }

    .copdNumb {
      margin: 40px 0;
    }

    .steam {
      padding: 40px 0;
      display: flex;
      justify-content: space-between;
      .steam-text {
        width: 60%;
        h1 {
          font-size: 1.2rem;
          color: #1e6fb9;
          font-weight: bold;
        }
      }
      .steam-img {
        width: 38%;
        display: flex;
        justify-content: space-around;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/product/ManZu1.vue